// extracted by mini-css-extract-plugin
export default {"warningMsg":"Auth_warningMsg__dIEWq"};